<template lang="html">
  <div
    id="weekplanInfo"
    v-loading.fullscreen.lock.body="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <navBar
      :tags="tags"
      :title="titleName"
      :subTitle="subTitle"
      :btnAgree="agreedOnOff"
      :btnRefuse="refusedOnOff"
      :btnSubmit="submitOnOff"
      :btnSave="saveOnOff"
      :btnBack="true"
      @btnDeleteClick="btnDeleteClick"
      @btnAgreeClick="btnAgreeClick"
      @btnRefuseClick="btnRefuseClick"
      @btnSubmitClick="btnSubmitClick"
      @btnSaveClick="inputBtnSaveClick"
      @btnBackClick="handleBackClick"
      @btnSaves="inputBtnSaveClick"
      :btnSaves="true"
    />
    <div>
      <el-tabs v-model="activeName" @tab-click="handleTabClick" :before-leave="beforeHandle">
        <div style="width: 80%;margin-top:10px;float: left;">
          <el-form
            v-if="rows == 'det'"
            label-width="120px"
            :model="form"
            :disabled="onOff"
            ref="formWeekInfo"
            style="margin-left: 80px;"
          >
            <el-row>
              <el-col>
                <el-form-item label="选择日期" prop="date">
                  <!-- <el-date-picker v-model="value1" type="date" placeholder="选择日期"> </el-date-picker> -->
                  <el-date-picker
                    v-model="form.plan_date"
                    type="date"
                    format="yyyy年M月d日"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    style="width: 100%"
                    :picker-options="pickerOptions"
                    disabled
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="所属辖区" prop="territory_id">
                  <!-- <el-select v-model="value" placeholder="请选择" @change="changeSelect">
                    <el-option v-for="item in territoryArray" :key="item.territory_id" :label="item.territory_name" :value="item.territory_id">
                    </el-option>
                  </el-select> -->
                  <el-select
                    v-model="form.territory_id"
                    style="width: 100%"
                    clearable
                    disabled
                    @change="changeSelect"
                  >
                    <el-option
                      v-for="item in territoryArray"
                      :key="item.territory_id"
                      :label="item.territory_name"
                      :value="item.territory_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="每日计划">
                  <el-input
                    type="textarea"
                    :rows="4"
                    class="weekPlanInfoInput"
                    v-model="form.plan_details"
                    placeholder="主推新产品，邀请客户参加第三季度的市场推广活动"
                    :disabled="ifTime ? (ifsysTime ? true : false) : true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="计划评价">
                  <el-input
                    type="textarea"
                    :rows="2"
                    class="weekPlanInfoInput"
                    v-model="form.plan_comment"
                    placeholder="上级主管评价..."
                    :disabled="form.plan_details ? (name_id != people_id ? (!ifsumTime ? false : true) : true) : true"
                  ></el-input>
                  <!-- 不是自己 -->
                  <!-- 第一层有数据传假在判断自否是自己传假 -->
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="每日小结">
                  <el-input
                    type="textarea"
                    :rows="4"
                    class="weekPlanInfoInput"
                    v-model="form.summary_details"
                    placeholder="主推新产品，邀请客户参加第三季度的市场推广活动"
                    :disabled="ifsumcurrentdate ? (ifsum ? false : true) : true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="小结评价">
                  <el-input
                    type="textarea"
                    :rows="2"
                    class="weekPlanInfoInput"
                    v-model="form.summary_comment"
                    placeholder="上级主管评价..."
                    :disabled="
                      form.summary_details ? (name_id != people_id ? (!ifsumTime ? false : true) : true) : true
                    "
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-form
            v-if="rows == 'tod'"
            label-width="120px"
            :model="form"
            :disabled="onOff"
            ref="formWeekInfo"
            style="margin-left: 80px;"
          >
            <el-row>
              <el-col>
                <el-form-item label="选择日期" prop="date">
                  <!-- <el-date-picker v-model="value1" type="date" placeholder="选择日期"> </el-date-picker> -->
                  <el-date-picker
                    v-model="form.plan_date"
                    type="date"
                    format="yyyy年M月d日"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    style="width: 100%"
                    :picker-options="pickerOptions"
                    disabled
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="所属辖区" prop="territory_id">
                  <!-- <el-select v-model="value" placeholder="请选择" @change="changeSelect">
                    <el-option v-for="item in territoryArray" :key="item.territory_id" :label="item.territory_name" :value="item.territory_id">
                    </el-option>
                  </el-select> -->
                  <el-select v-model="form.territory_id" style="width: 100%" clearable @change="changeSelect">
                    <el-option
                      v-for="item in territoryArray"
                      :key="item.territory_id"
                      :label="item.territory_name"
                      :value="item.territory_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="每日计划">
                  <el-input
                    type="textarea"
                    :rows="4"
                    class="weekPlanInfoInput"
                    v-model="form.plan_details"
                    placeholder="主推新产品，邀请客户参加第三季度的市场推广活动"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="计划评价">
                  <el-input
                    type="textarea"
                    :rows="2"
                    class="weekPlanInfoInput"
                    v-model="form.plan_comment"
                    placeholder="上级主管评价..."
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="每日小结">
                  <el-input
                    type="textarea"
                    :rows="4"
                    class="weekPlanInfoInput"
                    v-model="form.summary_details"
                    placeholder="主推新产品，邀请客户参加第三季度的市场推广活动"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="小结评价">
                  <el-input
                    type="textarea"
                    :rows="2"
                    class="weekPlanInfoInput"
                    v-model="form.summary_comment"
                    placeholder="上级主管评价..."
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-form
            v-if="rows == 'tom'"
            label-width="120px"
            :model="form"
            :disabled="onOff"
            ref="formWeekInfo"
            style="margin-left: 80px;"
          >
            <el-row>
              <el-col>
                <el-form-item label="选择日期" prop="date">
                  <!-- <el-date-picker v-model="value1" type="date" placeholder="选择日期"> </el-date-picker> -->
                  <el-date-picker
                    v-model="form.plan_date"
                    type="date"
                    format="yyyy年M月d日"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    style="width: 100%"
                    :picker-options="pickerOptions"
                    disabled
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="所属辖区" prop="territory_id">
                  <!-- <el-select v-model="value" placeholder="请选择" @change="changeSelect">
                    <el-option v-for="item in territoryArray" :key="item.territory_id" :label="item.territory_name" :value="item.territory_id">
                    </el-option>
                  </el-select> -->
                  <el-select v-model="form.territory_id" style="width: 100%" clearable @change="changeSelect">
                    <el-option
                      v-for="item in territoryArray"
                      :key="item.territory_id"
                      :label="item.territory_name"
                      :value="item.territory_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="每日计划">
                  <el-input
                    type="textarea"
                    :rows="4"
                    class="weekPlanInfoInput"
                    v-model="form.plan_details"
                    placeholder="主推新产品，邀请客户参加第三季度的市场推广活动"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="计划评价">
                  <el-input
                    type="textarea"
                    :rows="2"
                    class="weekPlanInfoInput"
                    v-model="form.plan_comment"
                    placeholder="上级主管评价..."
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="每日小结">
                  <el-input
                    type="textarea"
                    :rows="4"
                    class="weekPlanInfoInput"
                    v-model="form.summary_details"
                    placeholder="主推新产品，邀请客户参加第三季度的市场推广活动"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="小结评价">
                  <el-input
                    type="textarea"
                    :rows="2"
                    class="weekPlanInfoInput"
                    v-model="form.summary_comment"
                    placeholder="上级主管评价..."
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-form
            v-if="rows == 'sum'"
            label-width="120px"
            :model="form"
            :disabled="onOff"
            ref="formWeekInfo"
            style="margin-left: 80px;"
          >
            <el-row>
              <el-col>
                <el-form-item label="选择日期" prop="date">
                  <!-- <el-date-picker v-model="value1" type="date" placeholder="选择日期"> </el-date-picker> -->
                  <el-date-picker
                    v-model="form.plan_date"
                    type="date"
                    format="yyyy年M月d日"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    style="width: 100%"
                    :picker-options="pickerOptions"
                    disabled
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="所属辖区" prop="territory_id">
                  <!-- <el-select v-model="value" placeholder="请选择" @change="changeSelect">
                    <el-option v-for="item in territoryArray" :key="item.territory_id" :label="item.territory_name" :value="item.territory_id">
                    </el-option>
                  </el-select> -->
                  <el-select v-model="form.territory_id" style="width: 100%" clearable @change="changeSelect">
                    <el-option
                      v-for="item in territoryArray"
                      :key="item.territory_id"
                      :label="item.territory_name"
                      :value="item.territory_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="每日计划">
                  <el-input
                    type="textarea"
                    :rows="4"
                    class="weekPlanInfoInput"
                    v-model="form.plan_details"
                    placeholder="主推新产品，邀请客户参加第三季度的市场推广活动"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="计划评价">
                  <el-input
                    type="textarea"
                    :rows="2"
                    class="weekPlanInfoInput"
                    v-model="form.plan_comment"
                    placeholder="上级主管评价..."
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="每日小结">
                  <el-input
                    type="textarea"
                    :rows="4"
                    class="weekPlanInfoInput"
                    v-model="form.summary_details"
                    placeholder="主推新产品，邀请客户参加第三季度的市场推广活动"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="小结评价">
                  <el-input
                    type="textarea"
                    :rows="2"
                    class="weekPlanInfoInput"
                    v-model="form.summary_comment"
                    placeholder="上级主管评价..."
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-tabs>
    </div>
    <el-dialog
      id="travelSavePlanPs"
      :visible.sync="modelSavePlanPs"
      :show-close="false"
      :before-close="handleClose"
      style="vertical-align: center;: #FFF9F3"
    >
      <div style="">
        <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
          <el-col :span="12">
            <div style="color: #3998F7;padding-top: 8px;font-size: 20px">写一笔</div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="primary" size="small" @click="savePlanPs()">
                保存
              </el-button>
              <el-button type="danger" size="small" @click="modelSavePlanPs = false">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="margin-top: 20px">
        <el-input type="textarea" v-model="contents"> </el-input>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import navBar from '../../../components/navBar'
import http from '../../../APIService/http'
import moment from 'moment'
import noCheck from '../../../assets/images/noCheck.png'
import inCheck from '../../../assets/images/speakers.png'
import tou from '../../../assets/images/tou.png'
import weekday from './components/weekday'
import weekday1 from './components/weekday1'
import weekday2 from './components/weekday2'
import weekday3 from './components/weekday3'
import weekday4 from './components/weekday4'
import weekday5 from './components/weekday5'
import weekday6 from './components/weekday6'
import weekday7 from './components/weekday7'

export default {
  name: 'medical',
  data() {
    return {
      plan_date: '',
      plan_details: '',
      plan_comment: '',
      summary_details: '',
      summary_comment: '',
      user_name: '',
      id: '',
      loading: false,
      tags: ['日程安排', '计划小结'],
      titleName: this.$store.getters.getUser.alias,
      title: this.$store.getters.getUser.role === 'staff' ? this.$store.getters.getUser.alias : '管理员',
      subTitle: '',
      data: {},
      datePlan: '',
      value1: [],
      noCheck: noCheck,
      inCheck: inCheck,
      form: {
        datePlan: '',
        comments: '',
        distributorArray: [],
        created_by: '',
        end_date: '',
        institutionsArray: [],
        meetingArray: [],
        coachArray: [],
        plan_id: '',
        psArray: [],
        retailstoreArray: [],
        start_date: '',
        status: '',
        datePlanTime: '',
        datePlanInfo: '',
        selectDate: '',
        plan_date: '',
        plan_details: '',
        plan_comment: '',
        summary_details: '',
        summary_comment: '',
        user_name: '',
      },
      datePlanTime: '',
      options: [
        {
          label: 1,
          value: 1,
        },
        {
          label: 2,
          value: 2,
        },
        {
          label: 3,
          value: 3,
        },
      ],
      status: '', //new新增  info详情
      modelSavePlanPs: false,
      medicalVisitModel: false,
      medicalVisitModelStore: false,
      medicalVisitModelDis: false,
      medicalVisitModelMee: false,
      institutionModel: {
        institutionsArray: [],
        instutionsHcpList: [],
      },
      storesArrayModel: [],
      disArrayModel: {
        distributorArray: [],
        contactArray: [],
      },
      meeArrayModel: [],
      copyInsArray: [],
      copyStoreArray: [],
      copyDisArray: [],
      copyMeeArray: [],
      contents: '',
      onOff: false,
      managerOnOff1: false,
      rows: '',
      agreedOnOff: false,
      refusedOnOff: false,
      submitOnOff: false,
      saveOnOff: false,
      deleteOnOff: false,
      formSelectDate: [],
      pickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          let now = moment()
            .add('days', 28)
            .valueOf()
          let weekOfday = moment(now).format('E') //获取在一周的第几天
          let dateConstSunday = moment(now)
            .subtract(weekOfday - 7, 'days')
            .valueOf()
          return time.getTime() < Date.now() || time.getTime() > dateConstSunday
        },
      },
      clientObj: {},
      activeName: 'first',
      unAssign: 0,
      territoryArray: [],
      MondayNum: 0,
      TuesdayNum: 0,
      WednesdayNum: 0,
      ThursdayNum: 0,
      FridayNum: 0,
      SaturdayNum: 0,
      SundayNum: 0,
      unAssignArr: [],
      MondayArr: [],
      TuesdayArr: [],
      WednesdayArr: [],
      ThursdayArr: [],
      FridayArr: [],
      SaturdayArr: [],
      SundayArr: [],
      sendArray: [],
      copyForm: {},
      selectDate: '',
      isShowTab: true,
      deleteArr: [],
      name_id: '',
      people_id: '',
      dir: true,
      ifTime: '',
      ifsysTime: '',
      ifsum: '',
      num: '',
      ifsumTime: '',
      configObj: {},
    }
  },
  filters: {
    componentFliter: function(value) {
      return moment(value).format('YYYY-M-D HH:mm:ss')
    },
    titleFilter: function(value) {
      if (value === undefined || value === '') {
        return ''
      } else {
        return '-' + value
      }
    },
    weekDayFilter: function(value) {
      if (value == '' || value == null) {
        return ''
      } else {
        let dateObject = new Date(value)
        let weekDay = dateObject.getDay()
        switch (weekDay) {
          case 1:
            return '周一: '
            break
          case 2:
            return '周二: '
            break
          case 3:
            return '周三: '
            break
          case 4:
            return '周四: '
            break
          case 5:
            return '周五: '
            break
          case 6:
            return '周六: '
            break
          case 0:
            return '周日: '
            break
        }
      }
    },
    filter_covegr: function(item) {
      if (item.calls == '0' && item.campaigns == '0') {
        return '本月尚未覆盖'
      } else {
        let str = ''
        if (item.calls != '0') {
          str = '本月已覆盖(医务拜访'
        }
        if (item.campaigns != '0') {
          if (str != '') {
            str = str + '、科室会'
          } else {
            str = str + '本月已覆盖(科室会'
          }
        }
        if (str != '') {
          str = str + ')'
        }
        return str
      }
    },
  },
  computed: {
    // datePlanTime(){
    //     return this.form.datePlanTime
    // }
  },
  watch: {
    datePlanTime(newVal, oldVal) {
      // console.log(newVal)
      let date = moment(newVal).format('YYYY-MM-DD')
      if (newVal !== '') {
        this.form.selectDate = date
      } else {
        this.form.selectDate = ''
      }

      let weekOfday = moment(date).format('E') //获取在一周的第几天
      let dateConst = moment(date)
        .subtract(weekOfday - 1, 'days')
        .format('YYYY年MM月DD日') //周一日期
      this.form.start_date = moment(date)
        .subtract(weekOfday - 1, 'days')
        .format('YYYY-MM-DD')
      this.form.end_date = moment(date)
        .subtract(weekOfday - 7, 'days')
        .format('YYYY-MM-DD')
      if (this.status === 'NEW') {
        let dateConstSunday = moment(date)
          .subtract(weekOfday - 7, 'days')
          .format('YYYY年MM月DD日') //周日日期
        if (newVal) {
          this.form.datePlanInfo = dateConst + '-' + dateConstSunday
        } else {
          this.form.datePlanInfo = ''
        }
      }
    },
  },
  components: {
    navBar,
    weekday,
    weekday1,
    weekday2,
    weekday3,
    weekday4,
    weekday5,
    weekday6,
    weekday7,
    // Upload
  },
  created() {
    this.clientObj = this.$store.getters.getClient
  },
  mounted() {
    debugger
    this.form = this.$route.params.row
    this.rows = this.$route.params.row.type
    this.name_id = this.$route.params.row.user_id
    this.configObj = this.$route.params.configObj
    this.people_id = this.$store.getters.getUser.user_id
    this.getTerritory()
    this.ifPlan()
  },
  methods: {
    ifPlan() {
      let currentDate = new Date().toTimeString()
      //填写日期  今日日期
      // 14号都为真
      //如果日期是今天以前传真，不是今天以前传假
      this.ifTime =
        moment(this.form.plan_date).format('YYYY年MM月DD日') >= moment().format('YYYY年MM月DD日') ? true : false
      this.ifsysTime =
        this.time_to_sec(currentDate) > this.time_to_sec(this.configObj.parameter.PLAN_SUMMARY_PLAN_CLOSE_TIME)
          ? true
          : false

      this.ifsumcurrentdate =
        moment(this.form.plan_date).format('YYYY年MM月DD日') == moment().format('YYYY年MM月DD日') ? true : false
      this.ifsum =
        this.time_to_sec(this.configObj.parameter.PLAN_SUMMARY_SUMMARY_START_TIME) < this.time_to_sec(currentDate)
          ? true
          : false
      let num = +this.configObj.parameter.PLAN_SUMMARY_COMMENT_DATE
      this.ifsumTime =
        moment()
          .subtract(num, 'd')
          .format('YYYY年MM月DD日') > moment(this.form.plan_date).format('YYYY年MM月DD日')
          ? true
          : false
      //15hao   12hao
      // 11.20   17.26
    },
    time_to_sec(time) {
      if (time !== null) {
        var s = ''
        var hour = time.split(':')[0]
        var min = time.split(':')[1]
        // var sec = time.split(":")[2];
        // s = Number(hour * 3600) + Number(min * 60) + Number(sec);
        s = Number(hour * 3600) + Number(min * 60)
        return s
      }
    },
    handleAddSaves() {
      let row = {
        type: 'sum',
      }
      this.$router.push({ name: 'planSummaryInfo', params: row })
    },
    changeSelect() {
      this.$forceUpdate()
    },
    getTerritory() {
      var user = this.$store.getters.getUser
      let data = {
        user_id: user.user_id,
        tenant_id: user.tenant_id,
        search: '',
        month: moment().format('YYYYMM'),
        type: true,
        isAdmin: false,
        role: user.role,
      }
      if (this.class_active) {
        data.type = true
      } else {
        data.type = false
      }
      if (user.role === 'admin') {
        data.isAdmin = true
      }

      http.post('/wapi/Conference/getTerritory', data).then((res) => {
        if (res.success === true) {
          this.territoryArray = res.data
          debugger
          if (this.rows == 'tod' || this.rows == 'sum') {
            this.form.plan_date = moment().format('YYYY-MM-DD')
          }
          if (this.rows == 'tom') {
            this.form.plan_date = moment()
              .add(1, 'days')
              .format('YYYY-MM-DD')
          }
        } else {
        }
      })
    },
    handleBackClick() {
      this.$router.go(-1)
    },
    inputBtnSaveClick() {
      this.$refs['formWeekInfo'].validate((valid) => {
        console.log(valid)
        if (!valid) {
          return false
        } else {
          this.btnSaveClick()
        }
      })
    },
    async btnSaveClick(type) {
      try {
        let data = this.form
        data.tenant_id = this.$store.getters.getUser.tenant_id
        data.user_id = this.$store.getters.getUser.user_id
        data.plan_date = this.form.plan_date
        debugger
        let url = '/crm/activity/plan_summary/saveActivityDayPlan'
        if (this.rows == 'tod' || this.rows == 'tom') {
          data.plan_details = this.form.plan_details
        } else if (this.rows == 'sum') {
          url = '/crm/activity/plan_summary/saveActivityDaySummary'
          data.summary_details = this.form.summary_details
        } else {
          debugger
          if (this.rows == 'det' && this.name_id != this.people_id) {
            url = '/crm/activity/plan_summary/saveActivityDayPlanComment'
            data.plan_comment = this.form.plan_comment
            data.summary_comment = this.form.summary_comment
          } else {
            url = '/crm/activity/plan_summary/saveActivityDayPlanSummary'
            data.plan_details = this.form.plan_details
            data.summary_details = this.form.summary_details
          }
        }
        // 每日计划
        // data.plan_details = this.form.plan_details
        // 每日小结
        // data.summary_details=this.form.summary_details
        // 计划评价与小结评价
        // (data.plan_comment = this.plan_comment)
        // data.summary_comment = this.summary_comment
        if (!data.plan_date) {
          this.$message({
            type: 'error',
            message: '请选择计划日期',
          })
          return false
        }
        let loading = this.$loading({
          lock: true,
          text: '拼命加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        await http.post(url, data).then((res) => {
          if (res.success === true) {
            //this.init()
            this.$message({
              type: 'success',
              message: '提交成功',
            })
            this.$router.push({
              name: 'planSummary',
            })
          }
        })
      } catch (e) {
        loading.close()
      }
    },
  },
}
</script>

<style scoped>
/*#container {*/
/*    background: #fff;*/
/*    padding: 0px 50px;*/
/*    height: 100%;*/
/*    box-sizing: border-box;*/
/*}*/
#weekplanInfo {
  height: 100%;
}
#weekplanInfo >>> .el-form-item__label {
  font-size: 16px;
  color: #000000;
  padding-left: 0px;
  text-align: left;
  padding-right: 40px;
}
#weekplanInfo >>> .el-table_1_column_7 {
  color: #3b99f7;
}
#weekplanInfo >>> .el-table th {
  padding: 7px 0px;
}
#weekplanInfo >>> .el-table td {
  padding: 7px 0px;
}
#weekplanInfo .box-card {
  width: 100%;
  box-shadow: none;
  min-height: 40px;
}
#weekplanInfo >>> .el-icon-edit-outline:before {
  margin-right: 5px;
}
#weekplanInfo >>> .el-icon-time:before {
  margin-right: 5px;
}
#weekplanInfo >>> .el-icon-edit-outline:before {
  font-size: 16px;
}
#weekplanInfo >>> .el-icon-edit-outline span {
  position: relative;
  top: -2px;
  font-size: 13px;
}
#weekplanInfo .institutionTitle >>> .el-form-item__label {
  color: #59c95d;
}
#weekplanInfo .distributorTitle >>> .el-form-item__label {
  color: #f65272;
}
#weekplanInfo .storeTitle >>> .el-form-item__label {
  color: #fe8d40;
}
#weekplanInfo .meetingTitle >>> .el-form-item__label {
  color: #9a3bfe;
}
#weekplanInfo .coachTitle >>> .el-form-item__label {
  color: #2689f7;
}
</style>

<style>
#weekplanInfo .el-card__body {
  padding: 0px 20px 5px;
}
#weekplanInfo #travelSavePlanPs .el-textarea__inner {
  height: 400px;
}
#weekplanInfo .weekPlanInfoInput .el-input__inner {
  border: 1px solid #ebeef5;
}
#weekplanInfo .el-dialog__header {
  padding: 0px;
}
[v-cloak] {
  display: none;
}
#weekplanInfo .el-button--warning {
  color: #fff;
  background-color: #ff9901;
  border-color: #ff9901;
}
#weekplanInfo .el-button--warning:hover {
  background: #ebb563;
  border-color: #ebb563;
  color: #fff;
}
#weekplanInfo .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  float: right;
}
#weekplanInfo h4 {
  border-bottom: none;
  margin-bottom: 0;
}
#weekplanInfo .el-tab-pane:after {
  content: '';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/calendar/components/planSummaryInfo.vue